import _CONST from '@/const/global.js'

const languageAliasCodes = new Set(Object.values(_CONST.languageOptions))

/**
 * 将账号语言数字值或 locale 转换为语言接口的 aliasCode。
 * 例如：1 -> zh、2 -> en、zh-CN -> zh。
 */
export function getLanguageAliasCode(language) {
  const value = String(language || '')
  if (_CONST.languageOptions[value]) return _CONST.languageOptions[value]

  const aliasCode = value.split('-')[0].toLowerCase()
  if (languageAliasCodes.has(aliasCode)) return aliasCode

  return _CONST.languageOptions[localStorage.getItem('lang')] || 'en'
}

/**
 * 将 aliasCode 映射为语言接口返回的 code，供字典接口 accept-language 使用。
 * 例如：zh -> zh-CN、en -> en-US。
 */
export function getDictionaryLanguageCode(language) {
  const aliasCode = getLanguageAliasCode(language)
  return _CONST.languageAliasCodeOptions[aliasCode] || _CONST.languageAliasCodeOptions.en
}

export function getConfiguredDictionaryProjects() {
  return String(import.meta.env.VITE_DICTIONARY_PROJECTS || '')
    .split(',')
    .map((projectCode) => projectCode.trim())
    .filter(Boolean)
}
